/**
 * @generated SignedSource<<57fb73c1936cc2806792ef303718c3cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type importSageIntacctExpenseItemModal_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly " $fragmentType": "importSageIntacctExpenseItemModal_viewer";
};
export type importSageIntacctExpenseItemModal_viewer$key = {
  readonly " $data"?: importSageIntacctExpenseItemModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"importSageIntacctExpenseItemModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "importSageIntacctExpenseItemModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2c006bbf80244123db7e251250f259a1";

export default node;
